export const ALL_AVAILABLE_PLANS_LABELS = {
  TITLE: 'All Available Plans',
  PRICE_FOR: 'Price For',
  MONTH: 'Month',
  MONTHS: 'Months',
  OFF_MONTHLY_PRICE: 'Off Monthly Price',
  BENEFITS: 'Benefits:',
  SELECT_PLAN: 'SELECT PLAN',
  ACTIVE: 'Active',
  BACK_TO_PLANS: 'Back to Plans',
  ALREADY_SUBSCRIBED: 'This subscription plan is already subscribed.',
  DOWNGRADE: 'downGrade',
  UPGRADE: 'upGrade',
  MOVE_AHEAD: 'move-ahead',
  UNLOCK_CONTENT: 'To unlock this content, please choose one of the subscription plans below:',
  NO_PLAN_AVAILABLE: 'No Plans Available to Subscribe',
  LOADING_SUBS: 'Loading Subscriptions...',
  INCLUDED_BENEFITS: 'Included Benefits:',
};
